import { motion } from "framer-motion";
import { ShieldCheck, Award, Leaf, FileCheck2, Sprout, MapPin } from "lucide-react";

const BADGES = [
  { icon: ShieldCheck, label: "FAA Part 137 Certified", sub: "Federal Aviation Administration" },
  { icon: Award, label: "Licensed Applicators", sub: "Florida FDACS" },
  { icon: Leaf, label: "EPA-Compliant", sub: "Approved Chemistries" },
  { icon: FileCheck2, label: "Fully Insured", sub: "$2M Liability Coverage" },
  { icon: Sprout, label: "Drone Pilot Certified", sub: "FAA Part 107" },
  { icon: MapPin, label: "South Florida Specialists", sub: "Homestead · Miami-Dade · Broward" },
];

export default function TrustSignals() {
  return (
    <section data-testid="trust-signals" className="py-14 md:py-16 bg-background border-y border-border">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-accent">Trusted, licensed, insured</p>
          <h2 className="font-display text-2xl md:text-3xl text-primary font-bold mt-2">
            FAA-Certified Agricultural Drone Services for Florida Farms
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {BADGES.map((b, i) => {
            const Icon = b.icon;
            return (
              <motion.div
                key={b.label}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.04 }}
                className="flex flex-col items-center text-center p-5 rounded-2xl bg-card border border-border shadow-card hover:shadow-card-hover hover:border-accent/40 transition-all"
              >
                <div className="h-12 w-12 rounded-2xl bg-accent/10 text-accent flex items-center justify-center mb-3">
                  <Icon className="h-5 w-5" />
                </div>
                <div className="font-display text-sm font-bold text-primary leading-tight">{b.label}</div>
                <div className="text-xs text-muted-foreground mt-1">{b.sub}</div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
